import { render, staticRenderFns } from "./ApplyRecord.vue?vue&type=template&id=528f3394&scoped=true"
import script from "./ApplyRecord.vue?vue&type=script&lang=js"
export * from "./ApplyRecord.vue?vue&type=script&lang=js"
import style0 from "./ApplyRecord.vue?vue&type=style&index=0&id=528f3394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f3394",
  null
  
)

export default component.exports